
const BASE_API = process.env.REACT_APP_API_URL;
export {BASE_API};